import { useMemo } from 'react';
import { useRedesignNavigation } from 'root/src/client/v2/layout/features/RedesignNavbar/useRedesignNavigation';
// Command-palette adapter over the shared redesign navigation. Everything (destinations, role gating,
// icons, keywords) comes from useRedesignNavigation, so the palette can never miss a page the navbar
// offers. Links open with a full page load (matching the navbar's <a> destinations); actions run their
// shared handler. Clips is gated by the reviewer role only (no `?mock=1` preview in the palette).
export const useRedesignNavItems = () => {
    const { primary, account } = useRedesignNavigation();
    return useMemo(() => {
        const toItem = (entry) => ({
            id: entry.id,
            label: entry.label,
            Icon: entry.Icon,
            keywords: entry.keywords,
            onSelect: entry.kind === 'link'
                ? () => {
                    if (entry.newTab) {
                        window.open(entry.href, '_blank', 'noopener');
                        return;
                    }
                    window.location.assign(entry.href);
                }
                : entry.onSelect,
        });
        const groups = [{ heading: 'Pages', items: primary.map(toItem) }];
        if (account.length > 0) {
            groups.push({ heading: 'Account', items: account.map(toItem) });
        }
        return groups;
    }, [primary, account]);
};
